module.exports = {
  URL_LOCALHOST_FRONTEND: "http://localhost:8080",
  URL_LOCALHOST_BACKEND: "http://localhost:10010",
  URL_DOMAIN_WEBSITE_PROD: "https://www.milklovethailand.com",
  URL_DOMAIN_WEBSITE_PREVIEW: "http://milklove-th-web-preview.vercel.app",
  URL_2024_FANDAY_IN_BKK_PROJECT:
    "20241001-donate-project-milklove-fanday-2024",
  URL_2024_FANDAY_IN_BKK_PROJECT_FORM_SCRIPT:
    "https://script.google.com/macros/s/AKfycbw9eSgOCIexX-CleKWzaSTwFsZYA7nnuWlkj0ggIK3RIPRG5exTe_QV3KFlkXlroEvm/exec",
  URL_2025_BB_FANFEST_PROJECT:
    "20250501-donate-project-milklove-bb-fanfest-2025",
  URL_2025_BB_FANFEST_PROJECT_FORM_SCRIPT:
    "https://script.google.com/macros/s/AKfycbycma3AnjpV2ycbtdQY_nwwh2T5ramw52M1gBI2WEZzEXWALOYEKPq6a4N41VqvtRaCaA/exec",
  URL_2025_MILK_BD_PROJECT:
    "20250717-donate-project-milk-bd-2025",
  URL_2025_MILK_BD_PROJECT_FORM_SCRIPT:
    "https://script.google.com/macros/s/AKfycbyPHcRB3sjpzkY2eQ4ZFGE7bM286_6jBVOyEcFjUNNYushZ6u9NILCjEBVVML8T-nAyBQ/exec",
  URL_2025_STARLYMPICS_PROJECT:
    "20251021-donate-project-starlympics-2025",
  URL_2025_STARLYMPICS_PROJECT_FORM_SCRIPT:
    "https://script.google.com/macros/s/AKfycbzCD8vnPHo3OGUFiyStkR0rQQC9_P0IkgGMfSbiPukRWBOMmRA7fLjFJ1U3K3RRqtqIXw/exec",
  URL_2026_GIRLRULES_PROJECT:
    "20260225-donate-project-girlrules-2026",
  URL_2026_GIRLRULES_PROJECT_FORM_SCRIPT:
    "https://script.google.com/macros/s/AKfycbxJwqn6gz9VDH9MeehQCBNchMLM9XCU-Md90n5imiAtVKof4TrYagoweY3hohrGgHM8aA/exec",
  URL_2026_LOVEMUVBD_PROJECT:
    "20260410-donate-project-lovemuvbd-2026",
  URL_2026_LOVEMUVBD_PROJECT_FORM_SCRIPT:
    "https://script.google.com/macros/s/AKfycbyUDlOESI73LfGInIcZb9o835Eu2zenTiQG6NKp-J52pciD3d32Ig1u4HFeBoPlmbqU/exec",
  URL_2026_BBFANFEST_PROJECT:
    "20260512-donate-project-bbfanfest-2026",
  URL_2026_BBFANFEST_PROJECT_FORM_SCRIPT:
    "https://script.google.com/macros/s/AKfycbySvquJvRxBm8U7QiSe0vvfy2gElFb_o319LUUGsvgnZUqiRh3oLlfn_QSgmF98tBFL/exec",
};
